<template>
  <div class="article-frame">
    <div class="article-box article-box-bg">
      <img class="header-img" :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/pc_banner_sup_faq.webp`)">
      <div class="content pos-relative">
        <go-to-top />
        <sup-menu />
        <h1 class="main-title">
          登録方法
        </h1>

        <div class="tab-frame ">
          <!-- タブを構成するブロック -->
          <ul class="tab-list">
            <li id="pc-k" class="tab-list-item" :class="{'is-btn-active': isActive}" @click="toggleActive">
              PC版
            </li>
            <li id="mobile-k" class="tab-list-item" :class="{'is-btn-active': !isActive}" @click="toggleActive">
              モバイル版
            </li>
          </ul>

          <!-- コンテンツを構成するブロック -->
          <div class="tab-contents-wrap">
            <div class="tab-contents" :class="{'is-contents-active': isActive}">
              <h2 class="main-title">
                ステップ 1
              </h2>
              <h3 class="subheading fs_6">
                ホーム画面の「新規登録」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_pc_01.png`)" alt="Step 1: Click 'New Registration' on the home screen for PC.">
              </div>

              <h2 class="main-title">
                ステップ 2
              </h2>
              <h3 class="subheading fs_6">
                新規登録画面にて必要な情報を入力し、最後に「アカウントを作成」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_pc_02.png`)" alt="Step 2: Enter the required information on the new registration screen and click 'Create Account' for PC.">
              </div>

              <h2 class="main-title">
                ステップ 3
              </h2>
              <h3 class="subheading fs_6">
                認証コードがお客様が入力されたメールアドレスに届く
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_pc_03.png`)" alt="Step 3: The authentication code will be sent to the email address you entered.">
              </div>

              <h2 class="main-title">
                ステップ 4
              </h2>
              <h3 class="subheading fs_6">
                認証コードを入力し、「認証」をクリック
              </h3>
              <div class="img-style-bor-sha">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_pc_04.png`)" alt="Step 4: Enter the authentication code and click 'Authenticate'.">
              </div>

              <h2 class="main-title">
                ステップ 5
              </h2>
              <h3 class="subheading fs_6">
                登録完了
              </h3>
            </div>
            <!-- 使用PC版  -->

            <div class="tab-contents" :class="{'is-contents-active': !isActive}">
              <h2 class="main-title">
                ステップ 1
              </h2>
              <h3 class="subheading fs_6">
                ホーム画面の「新規登録」をクリック
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_mb_01.png`)" alt="Step 1: Click 'New Registration' on the home screen for mobile.">
              </div>

              <h2 class="main-title">
                ステップ 2
              </h2>
              <h3 class="subheading fs_6">
                新規登録画面にて必要な情報を入力し、最後に「アカウントを作成」をクリック
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_mb_02.png`)" alt="Step 2: Enter the required information on the new registration screen and click 'Create Account' for mobile.">
              </div>

              <h2 class="main-title">
                ステップ 3
              </h2>
              <h3 class="subheading fs_6">
                認証コードがお客様が入力されたメールアドレスに届く
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_mb_03.png`)" alt="Step 3: The authentication code will be sent to the email address you entered for mobile.">
              </div>

              <h2 class="main-title">
                ステップ 4
              </h2>
              <h3 class="subheading fs_6">
                認証コードを入力し、「認証」をクリック
              </h3>
              <div class="img-style-bor-sha mobile-pic">
                <img :src="require(`@/assets/${$store.getters.currentTheme}/images/sup/register_mb_04.png`)" alt="Step 4: Enter the authentication code and click 'Authenticate' for mobile.">
              </div>

              <h2 class="main-title">
                ステップ 5
              </h2>
              <h3 class="subheading fs_6">
                登録完了
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goToTop from '@/components/goToTop'
import supMenu from '@/views/page/sup/supMenu'

export default {
  components: {
    goToTop,
    supMenu
  },
  data() {
    return {
      isActive: true
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.app.metaInfo.title,
      meta: [
        {
          vmid: 'register',
          name: 'keywords',
          content: this.$store.state.app.metaInfo.keywords
        }, {
          name: 'description',
          content: this.$store.state.app.metaInfo.description
        }
      ]
    }
  },
  created() {
  },
  methods: {
    toggleActive() {
      this.isActive = !this.isActive
    }
  }
}
</script>
